import React, { Component } from 'react';
import PropTypes from 'prop-types'; // You need to add this dependency

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class BackButton extends Component {
  static contextTypes = {
    router: () => PropTypes.object.isRequired,
  };

  render() {
    const { to } = this.props;
    const { history } = this.context.router;
    return (
      <button className="backButton" onClick={to ? () => history.push(to) : history.goBack}>
        <FontAwesomeIcon icon={['fas', 'long-arrow-left']} />
        <p>{i18n.translate('general.back')}</p>
      </button>
    );
  }
}
